import { Activity } from "@finway-group/shared/lib/models"
import { Dispatch } from "redux"
import { ActivityService } from "Shared/services"
import { ActivityActionTypes, FetchActivityAction, markAllAsViewedAction, MarkAsViewedAction } from "./activityTypes"

export const fetchAllActivities =
    (page = 1, append = false) =>
    async (dispatch: Dispatch) => {
        const { docs, totalDocs, totalPages } = await ActivityService.fetchActivities(page)
        const totalUnseen = await ActivityService.fetchUnseenActivityCount()

        const fetchAllActivities: FetchActivityAction = {
            type: ActivityActionTypes.FETCH_ACTIVITY,
            activities: docs,
            totalUnseen,
            totalPages,
            totalDocs,
            append,
        }

        dispatch(fetchAllActivities)
        return docs
    }

export const markActivityAsViewed = (activity: Activity) => async (dispatch: Dispatch) => {
    await ActivityService.markAsViewed(activity)

    const markAsViewed: MarkAsViewedAction = {
        type: ActivityActionTypes.MARK_AS_VIEWED,
        activity,
    }

    dispatch(markAsViewed)
}

export const markAllAsViewed = (ids: string[], userId: string) => async (dispatch: Dispatch) => {
    await ActivityService.markAllAsViewed()
    const markAllAsViewed: markAllAsViewedAction = {
        type: ActivityActionTypes.MARK_ALL_AS_VIEWED,
        ids,
        userId,
    }

    dispatch(markAllAsViewed)
}
